export default __webpack_public_path__ + "static/media/ProfileImage.1fb00c31.jpg";